export default __webpack_public_path__ + "media/images/full_table_white-a7382a01d1ccf696b4388c8480ba5fa3.png";